export default {"src":"/_next/static/media/success.6feaab76.svg","height":100,"width":100};